import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST REQUEST FRANCHISE
export const requests = (params = '') => Http.get(`/service-personal-information${serialize(params)}`)

// DELETE FRANCHISE MESSAGE
export const deleteRequest = (params = '') => Http.delete(`/service-personal-information/${params.id}`)

// REQUEST FRANCHISE READ
export const updateRequests = (params = '') => Http.put(`/service-personal-information/${params.id}`, params)
